(function () {
  function normalize(str) {
    return (str || '').toLowerCase();
  }

  function bind(root) {
    var tabs = root.querySelectorAll('[data-manuals-tab]');
    var rows = root.querySelectorAll('[data-manuals-row]');
    var input = root.querySelector('[data-manuals-search]');
    var empty = root.querySelector('[data-manuals-empty]');
    if (!tabs.length || !rows.length) return;

    var activeSeries = root.getAttribute('data-manuals-default-series') || 'x';

    function setActiveTab(series) {
      activeSeries = series;
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-manuals-tab') === series;
        tab.classList.toggle('manuals-index-custom__tab--active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      filter();
    }

    function filter() {
      var q = input ? normalize(input.value.trim()) : '';
      var visible = 0;
      rows.forEach(function (row) {
        var series = row.getAttribute('data-series') || '';
        var hay = normalize(row.getAttribute('data-search') || '');
        var matchSeries = series === activeSeries;
        var matchQuery = !q || hay.indexOf(q) !== -1;
        var show = matchSeries && matchQuery;
        if (show) visible += 1;
        row.hidden = !show;
      });
      if (empty) {
        empty.hidden = visible !== 0;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var series = tab.getAttribute('data-manuals-tab');
        if (series) setActiveTab(series);
      });
    });

    if (input) {
      input.addEventListener('input', filter);
      input.addEventListener('change', filter);
    }

    setActiveTab(activeSeries);
  }

  document.querySelectorAll('[data-manuals-index]').forEach(bind);
})();
